
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {Stars} from '@/components';

export default {
name: 'evaluation-item',
components: {
Stars,
Previewer,
},
directives: {TransferDom},
props: {
evalItem: Object,
},
data(){
return {
previewList: [],     // 预览图片集合
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.img-position-center')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect();

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
},
},
};
},
created(){
this.resolveImgUrl();
},
methods: {
/** 播放视频 */
onPlayVideo(videoUrl){
this.$emit('on-player', videoUrl);
},

resolveImgUrl(){
const tempUrl = [];

this.evalItem.images.forEach(item => {
tempUrl.push({src: item.url, w: 600, h: 500});
});

this.previewList = tempUrl;
},

onShowIdx(idx){
this.$refs.previewer.show(idx);
},

},
}



// WEBPACK FOOTER //
// ./src/views/evaluation/components/EvaluationItem.vue